import { render, staticRenderFns } from "./ShowOrder.vue?vue&type=template&id=3f9ac44b"
import script from "./ShowOrder.ts?vue&type=script&lang=ts&external"
export * from "./ShowOrder.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports